<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title"> Call Center Bookings </div>
      <div class="row my-3">
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <label :class="
                 selectedCinema.cine_id
                    ? 'shift-up'
                    : ''
                ">
              {{ $t("select") }}
              {{ $tc("cinema", 1) }}</label>
            <multiselect :options="cinemasList" v-model="selectedCinema" :searchable="true" label="cine_name" track-by="cine_id" placeholder="Select Cinema" :allowEmpty="false" :showLabels="false"></multiselect>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <!-- <button class="btn-clearDate" v-if="fromDate">
                          ✖
                        </button> -->
              <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate" v-validate="'required'" @selected="onchangeDate($event, 'from')"></Datepicker>
              <label :class="fromDate ? 'active' : ''">
                <!-- {{ $t("show") }} -->
                {{ $t("fromdate") }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <!-- <button class="btn-clearDate" v-if="toDate">
                          ✖
                        </button> -->
              <Datepicker :monday-first="true" ref="programaticOpen" v-model="toDate" v-validate="'required'"></Datepicker>
              <label :class="toDate ? 'active' : ''">
                <!-- {{ $t("show") }}  -->
                {{ $t("todate") }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <label :class="
                 selectedFilter.value
                    ? 'shift-up'
                    : ''
                ">
              Filter Bookings</label>
            <multiselect :options="filters" v-model="selectedFilter" :searchable="true" label="label" track-by="value" placeholder="Select filter" :allowEmpty="false" :showLabels="false"></multiselect>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="input-material">
            <input v-model="searchValue" name="search_reservation" id="search_reservation" placeholder="Search Reservation" type="text" />
            <label>Search Reservation</label>
          </div>
        </div>

        <div class="col-lg-6 col-xl-2 align-self-center mb-3">
          <button class="btn-blue-lg w-100" @click.prevent="getCallCenterBookings()">
            {{ $t("fetch") }}
            {{ $t("report") }}
          </button>
        </div>
      </div>
      <div class="swc-report">
        <table class="swc-report-table" border="1" style="overflow-x:scroll;width: auto !important">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Username</th>
            <th>Reservation ID</th>
            <th>Business Date</th>
            <th>Reservation DateTime</th>
            <th>Show Date</th>
            <th>Show Time</th>
            <th>Cinema</th>
            <th>Screen</th>
            <th>Seats</th>
            <th>Customer Name</th>
            <th>Email</th>
            <th>Contact Number</th>
            <th>Action</th>
          </thead>
          <tbody v-if="callCenterBookings.length > 0">
            <tr v-for="(callCenterBookingsObj,callCenterBookingsIndex) in callCenterBookings" :key="callCenterBookingsIndex">
              <td class="text-left">{{callCenterBookingsObj.reserved_by}}</td>
              <td class="text-left">{{callCenterBookingsObj.reservation_id}}</td>
              <td class="text-left w-25">{{callCenterBookingsObj.business_date}}</td>
              <td class="text-left w-25">{{callCenterBookingsObj.reserved_at}}</td>
              <td class="text-left w-25">{{callCenterBookingsObj.show_date}}</td>
              <td class="text-left">{{callCenterBookingsObj.show_time}}</td>
              <td class="text-left">{{callCenterBookingsObj.cinema_name}}</td>
              <td class="text-left">{{callCenterBookingsObj.screen_name}}</td>
              <td class="text-left">{{callCenterBookingsObj.seat_names?callCenterBookingsObj.seat_names.split(",").join(", "):""}}</td>
              <td class="text-left">{{callCenterBookingsObj.customer_name || "-"}}</td>
              <td class="text-left">{{callCenterBookingsObj.customer_email || "-"}}</td>
              <td class="text-left">{{callCenterBookingsObj.customer_mobile || "-"}}</td>
              <td class="text-left" v-if="callCenterBookingsObj.is_booked=='N'">
                <button variant="default" @click="handleCancelPopup(callCenterBookingsObj.reservation_id)" class="btn-blue v-step-1">
                  {{
                    $tc("Cancel") }}
                </button>
              </td>
              <td class="text-center" v-else>
                Booked
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="13">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-modal id="confirmation" title="Delete Unpaid Booking?" hide-footer no-close-on-backdrop>
        <div class="text-center pb-1">
          <p class="fs-16 mb-2">
            {{
            `Are you sure you want to release Unpaid Booking For Reservation ID ${selectedReservation}`
          }}
          </p>

          <button class="btn-outline-blue" @click.prevent.stop="$bvModal.hide('confirmation')">
            Cancel
          </button>
          <span class="mx-1"></span>
          <button class="btn btn-danger btn-danger-lg px-4 fs-14" @click.prevent.stop="cancelUnpaidBooking">
            Confirm
          </button>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
  import {
    BASEURL
  } from "@/config/index";
  import ReportsService from "@/services/NewReportService";
  import MasterService from "@/services/MasterService";
  import ExhibitorService from "@/services/ExhibitorService";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import moment from "moment";

  export default {
    components: {
      NoRecords,
    },
    data() {
      return {
        selectedCinema: {
          cine_id: null,
          cine_name: null,
        },
        cinemasList: [],
        fromDate: new Date(),
        toDate: new Date(),
        callCenterBookings: [],
        filters: [{
          value: "is_reserved",
          label: "Reserved"
        }, {
          value: "is_booked",
          label: "Booked"
        }, {
          value: "all",
          label: "All"
        }],
        selectedFilter: {
          value: "all",
          label: "All"
        },
        searchValue: "",
        selectedReservation: ""
      };
    },
    beforeMount() {
      this.getCinemasList();
    },
    methods: {
      getCinemasList: async function() {
        try {
          const response = await MasterService.GetCinemas();

          const {
            data
          } = response || {};

          if (!data.status || !data.Records.length) {
            this.$toasted.show(data.message || "No records fetched..");
          }

          this.cinemasList = data.Records;
        } catch (error) {
          console.log(error);
        }
      },
      getCallCenterBookings: async function() {
        let loader = this.$loading.show();
        this.callCenterBookings = []
        try {
          if (!this.selectedCinema.cine_id) {
            return this.$toasted.show("Please select cinema");
          }
          let payload = {
            cinema_id: this.selectedCinema.cine_id,
            fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
            toDate: moment(this.toDate).format("YYYY-MM-DD")
          }
          if (this.selectedFilter.value == "is_reserved") {
            payload["is_reserved"] = true
          } else if (this.selectedFilter.value == "is_booked") {
            payload["is_booked"] = true
          }

          if (this.searchValue) {
            payload["search_value"] = this.searchValue
          }
          const response = await ReportsService.getCallCenterBookings(payload);

          loader.hide();

          const {
            data
          } = response || {};

          if (!data.status || !data.Records.length) {
            this.$toasted.show(data.message || "No records fetched..");
          }

          this.callCenterBookings = data.Records;
        } catch (error) {
          console.log(error);
        }
      },
      handleCancelPopup: function(reservation_id) {
        this.selectedReservation = reservation_id;
        this.$bvModal.show("confirmation");
      },
      cancelUnpaidBooking: async function() {
        let payload = {
          reservation_id: this.selectedReservation,
          cinema_id: this.selectedCinema.cine_id
        };
        try {
          const response = await ExhibitorService.CancelUnpaidBooking(payload)
          const {
            data
          } = response || {};
          if (data.status) {
            this.getCallCenterBookings();
          } else {
            this.$toasted.show(data.message);
          }
        } catch (error) {
          console.log(error)
        }
        this.$bvModal.hide("confirmation");

      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/CallCenterBookings.vue